import ModalShell from "./ModalShell";

export default function ConfirmSendResultsModal({
  open,
  email,
  onClose,
  onSend,
  onChangeEmail,
  onViewResults,
  sending,
}) {
  return (
    <ModalShell open={open} onClose={onClose} width={640}>
      <div className="p-5 bg-white text-center">
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 999,
            background: "#e9f8ef",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 22,
            color: "#0f8a4c",
          }}
          aria-hidden="true"
        >
          ✉
        </div>

        <div className="mt-3 fw-bold" style={{ fontSize: 26 }}>
          Send results to your email?
        </div>

        <div className="mt-2 text-muted" style={{ fontSize: 16 }}>
          We’ll send these results to <strong className="text-dark">{email}</strong>
        </div>

        {/* ✅ NEW BUTTON */}
        <button
          type="button"
          className="btn fw-semibold mt-4 w-100"
          onClick={onViewResults}
          style={{
            background: "transparent",
            borderColor: "#0f8a4c",
            color: "#0f8a4c",
            padding: "14px 16px",
            borderRadius: 14,
            fontSize: 16,
            borderWidth: 2,
          }}
        >
          View results
        </button>

        <button
          type="button"
          className="btn fw-semibold mt-3 w-100"
          onClick={onSend}
          disabled={sending}
          style={{
            background: "#0f8a4c",
            borderColor: "#0f8a4c",
            color: "white",
            padding: "14px 16px",
            borderRadius: 14,
            fontSize: 16,
          }}
        >
          {sending ? "Sending..." : "Send Results"}
        </button>

        <button
          type="button"
          className="btn btn-link mt-3 fw-semibold"
          onClick={onChangeEmail}
          style={{ textDecoration: "none" }}
        >
          Change Email
        </button>
      </div>
    </ModalShell>
  );
}
